/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation022.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation022Item {
  color: string;
  number: string;
  text: string;
}

interface IAnimation022Props {
  items: IAnimation022Item[];
  onCompleted: () => void;
}

const Animation022: FunctionComponent<IAnimation022Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation022 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className="animation022 component">
      <div className="animation022-content">
        {items.map((itm: IAnimation022Item, idx: number) => (
          <div
            key={idx}
            className={`animation022-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => clickToPlay()}
            style={{
              width: `${(1 / items.length) * 100 - 2}%`,
            }}
          >
            <>
              <img
                className="click-point"
                onClick={() => clickToPlay()}
                style={{
                  display: play <= 1 ? 'block' : 'none',
                }}
                src={ImgPoint}
                alt=""
              />
              <div className="animation022-number" style={{ color: itm.color }}>
                {itm.number}
              </div>
              <div
                className="animation022-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation022;
